import { render, staticRenderFns } from "./9.vue?vue&type=template&id=298b0dab&"
import script from "./9.vue?vue&type=script&lang=js&"
export * from "./9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports